import React from "react";

import { FlexContainer } from "@/components/Atoms/Box";
import MainTemplate from "@/components/Templates/MainTemplate";
import PageTitle from "./PageTitle";
import Sources from "./Sources";

import useDisableIntercom from "@/hooks/useDisableIntercom";

import { Description, PageWrapper, SectionsWrapper } from "./style";

import data from "./data";

const RecommendationSourcesPage = () => {
  useDisableIntercom();

  const { title, description, sections } = data || {};

  return (
    <MainTemplate hideFooter hideLinks hideRibbon>
      <FlexContainer>
        <PageWrapper>
          <PageTitle title={title} fontSize="28px" lineHeight="40px" />
          <Description variant="paragraph2">{description}</Description>
          <SectionsWrapper>
            {sections?.map((sources, index) => (
              <Sources key={index} {...sources} />
            ))}
          </SectionsWrapper>
        </PageWrapper>
      </FlexContainer>
    </MainTemplate>
  );
};

export default RecommendationSourcesPage;
